import { combineReducers } from 'redux';
import privacySettingsReducer from './containers/privacy-settings/reducer';
import languageProviderReducer from './containers/language-provider/reducer';
import activityAssignPreferenceReducer from './containers/activity-assign-preference/reducer';
import toastReducer from './components/toast/reducer';

const reducers = combineReducers({
    product: state => ({ ...state }),
    language: languageProviderReducer,
    privacySettings: privacySettingsReducer,
    activityAssignPreference: activityAssignPreferenceReducer,
    toast: toastReducer
});

export default reducers;



// WEBPACK FOOTER //
// ./app/reducers.js